import { Button, Typography } from '@mui/material'
import type { FC } from 'react'

import { LinkUnstyled, unit } from '@hcr/ui'

import { useUserDetails } from '../../../../contexts'
import { useHeroQuery } from '../../../../hooks/api/optimizely/queries'

import { HeaderHomeContainer } from './HeaderHomeContainer'
import { HeaderHomeLoading } from './HeaderHomeLoading'

export const HeaderHome: FC = () => {
  const userDetails = useUserDetails()
  const isOwner = userDetails?.data?.has_active_contracts
  const hero = useHeroQuery({ isOwner: !!isOwner })

  if (hero.isSuccess) {
    return (
      <HeaderHomeContainer>
        <Typography component='h1' variant='displayM' marginBottom={unit(2.5)}>
          {hero.data.heading}
        </Typography>
        <Typography component='h2' variant='displayS' marginBottom={unit(2.5)}>
          {hero.data.subHeading}
        </Typography>
        <Typography component='h3' variant='bodyM' marginBottom={unit(5)}>
          {hero.data.ingress}
        </Typography>
        <Button
          component={LinkUnstyled}
          to={hero.data.cta1Link.url}
          target={hero.data.cta1Link.target}
          variant='outlined'
          color='white'
        >
          {hero.data.cta1Link.label}
        </Button>
        {hero.data.cta2Link && (
          <Button
            component={LinkUnstyled}
            to={hero.data.cta2Link.url}
            target={hero.data.cta2Link.target}
            variant='outlined'
            color='white'
            sx={{ marginTop: unit(2.5) }}
          >
            {hero.data.cta2Link.label}
          </Button>
        )}
      </HeaderHomeContainer>
    )
  }

  return <HeaderHomeLoading />
}
